import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Crown, Mail, Lock, LogIn, Loader2 } from "lucide-react";

export function AdminLoginPage({
  loginEmail,
  setLoginEmail,
  loginPassword,
  setLoginPassword,
  loginLoading,
  handleLogin,
}) {
  return (
    <div
      className="min-h-screen bg-gray-950 flex items-center justify-center p-4"
      data-testid="platform-admin-login"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-emerald-500/20">
            <Crown className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-black text-white tracking-tight">
            Kaiso System
          </h1>
          <p className="text-gray-400 text-sm mt-1">
            Painel de Controle da Plataforma
          </p>
        </div>
        <Card className="bg-gray-900 border-gray-800">
          <CardContent className="p-6">
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label className="text-gray-300">Email do Administrador</Label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                  <Input
                    type="email"
                    value={loginEmail}
                    onChange={(e) => setLoginEmail(e.target.value)}
                    placeholder="seu@email.com"
                    className="pl-10 bg-gray-800 border-gray-700 text-white h-12"
                    data-testid="admin-login-email"
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label className="text-gray-300">Senha</Label>
                <div className="relative">
                  <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                  <Input
                    type="password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    placeholder="Sua senha"
                    className="pl-10 bg-gray-800 border-gray-700 text-white h-12"
                    data-testid="admin-login-password"
                    autoComplete="new-password"
                    required
                  />
                </div>
              </div>
              <Button
                type="submit"
                disabled={loginLoading}
                className="w-full h-12 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-bold"
                data-testid="admin-login-submit"
              >
                {loginLoading ? (
                  <Loader2 className="w-4 h-4 animate-spin mr-2" />
                ) : (
                  <LogIn className="w-4 h-4 mr-2" />
                )}
                Entrar no Admin Master
              </Button>
            </form>
          </CardContent>
        </Card>
        <p className="text-center text-gray-600 text-xs mt-4">
          Acesso restrito a administradores da plataforma Kaiso System
        </p>
      </div>
    </div>
  );
}
